import StorageService from './StorageService';

class SecureApiService {
    getSecureToken() {
        return 'mock-secure-token';
    }

    get secureStorage() {
        return {
            getSecureItem: (key) => {
                if (key === 'user_data') {
                    return { id: 1, name: 'Demo User', role: 'business' };
                }
                return StorageService.getItem(key);
            }
        };
    }

    async secureRequest(endpoint, options) {
        console.log(`[Mock] secureRequest to ${endpoint}`);
        if (endpoint.includes('/transactions')) {
            return { transactions: [] };
        }
        if (endpoint.includes('/accounts')) {
            return [];
        }
        return { success: true };
    }

    async secureLogin(credentials) {
        return { user: { id: 1, name: credentials.username, role: 'business' } };
    }

    async secureLogout() {
        StorageService.clear();
        return true;
    }

    async createSecureTransfer(data) {
        return { id: Math.floor(Math.random() * 100000).toString(), ...data };
    }
}

const secureApi = new SecureApiService();
export default secureApi;
